import { render } from "./UserRegisterDialog.vue?vue&type=template&id=86b2bf4c"
import script from "./UserRegisterDialog.vue?vue&type=script&lang=js"
export * from "./UserRegisterDialog.vue?vue&type=script&lang=js"

import "./UserRegisterDialog.vue?vue&type=style&index=0&id=86b2bf4c&lang=css"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__